import React, { useRef } from 'react';
import { Translate, useTranslate } from '@pegasus/translation';
import { CrossStrokeS } from '@lux/icons';
import { Text, Preset } from '@lux/text';

import Spinner from '../spinner/Spinner';
import * as S from './styles';

interface InfoBoxProps {
    title: string;
    iconComponent?: React.ReactNode;
    onCloseClick?: () => void;
    noCloseIcon?: boolean;
    sticky?: boolean;
    inline?: boolean;
    pending?: boolean;
    children: React.ReactNode;
}

export const InfoBox: React.FC<InfoBoxProps> = ({
    children,
    title,
    iconComponent = null,
    onCloseClick = null,
    noCloseIcon = false,
    sticky = false,
    inline = false,
    pending = false,
}) => {
    const translate = useTranslate();
    const contentRef = useRef<HTMLDivElement>(null);

    const getLoaderHeight = () => ({
        height: contentRef.current?.clientHeight ? `${contentRef.current.clientHeight}px` : 'auto',
    });

    return (
        <S.Wrapper sticky={sticky} inline={inline}>
            {!pending ? (
                <S.WrapperInner ref={contentRef}>
                    {iconComponent && (
                        <S.IconSection inline={inline}>{iconComponent}</S.IconSection>
                    )}
                    <S.ContentSection inline={inline} sticky={sticky}>
                        <Text preset={Preset.M} bold>
                            <Translate message={title} html />
                        </Text>
                        <S.Content>{children}</S.Content>
                    </S.ContentSection>
                </S.WrapperInner>
            ) : (
                <S.LoaderWrapper style={getLoaderHeight()}>
                    <S.Loader>
                        <Spinner />
                    </S.Loader>
                </S.LoaderWrapper>
            )}
            {!noCloseIcon && (
                <S.CloseIconWrapper aria-label={translate('close')} onClick={onCloseClick}>
                    <CrossStrokeS />
                </S.CloseIconWrapper>
            )}
        </S.Wrapper>
    );
};

export default InfoBox;
